import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  VStack,
} from '@chakra-ui/react';

import StoreItems from '~/components/StoreItems';

import { CartType, StoreOrderInCart } from '~/types/cart';

type InvalidOrdersModalProps = {
  isOpen: boolean;
  invalidOrders: Array<StoreOrderInCart>;
  cartType: CartType;
  onClose: () => void;
  onConfirm: () => void;
};

export default function InvalidOrdersModal({
  isOpen,
  invalidOrders,
  cartType,
  onClose,
  onConfirm,
}: InvalidOrdersModalProps) {
  return (
    <Modal
      size="sm"
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
      isCentered
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent mx={4}>
        <ModalHeader fontWeight="normal" fontSize="lg">
          以下品項無法在新的時段取餐，系統將會把餐點移除。<b>您可以選擇另外點選餐點或直接下單。</b>
        </ModalHeader>
        <ModalBody pb={4}>
          <VStack align="stretch">
            {invalidOrders.map((order) => (
              <StoreItems key={order.storeId} order={order} cartType={cartType} />
            ))}
          </VStack>
        </ModalBody>
        <ModalFooter p={0} borderTopWidth="1px" borderColor="gray.300">
          <Button isFullWidth size="md" fontWeight="normal" variant="unstyled" onClick={onConfirm}>
            暸解了
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
